import { ComponentProps } from 'react'

type Props = ComponentProps<'span'>

export const DotSeparator = (props: Props) => {
  // eslint-disable-next-line react/jsx-no-literals
  return <span {...props}>·</span>
}
